export const CUSTOMER_UUID = '';
export const APPLICATION_UUID = '';
export const START_STREAM_ID = '';
export const DEFAULT_USER_ID = '019ffc6b-b3bd-7c18-8cd2-27fac3a8d8f5';

export const API_MAPPING = {
    // GET_STATION_DEATILS: 'get_stations_details',
};

